import { render } from "./Aswiper.vue?vue&type=template&id=74db27e4&scoped=true"
import script from "./Aswiper.vue?vue&type=script&lang=js"
export * from "./Aswiper.vue?vue&type=script&lang=js"

import "./Aswiper.vue?vue&type=style&index=0&id=74db27e4&scoped=true&lang=css"

import exportComponent from "D:\\1\\2023-02-15\\doubles-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74db27e4"]])

export default __exports__